exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pro_checkout_items .checkout_item_remove {\n  text-align: center;\n}\n", ""]);

// exports
